import { makeAutoObservable, runInAction } from "mobx";
import Api from "../Components/Api";
import { BASE_API_URL } from "../Components/const";
import { getErrorMessage } from "../utils/errorHandler";

class ChannelStore {
  channels = [];
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  setChannels(data) {
    this.channels = data;
  }

  setLoading(value) {
    this.loading = value;
  }

  setError(error) {
    this.error = error;
  }

  async getChannels() {
    this.setLoading(true);
    this.setError(null);
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      runInAction(() => {
        this.setChannels(response.data.data);
        this.setLoading(false);
      });
      return response.data.data;
    } catch (error) {
      runInAction(() => {
        this.setError(error);
        this.setLoading(false);
      });
      console.error("Ошибка при получении списка каналов:", error);
      throw error;
    }
  }

  async addChannel(channelData) {
    this.setLoading(true);
    this.setError(null);
    try {
      const response = await Api.post(
        `${BASE_API_URL}/api/channel/add`,
        channelData
      );
      runInAction(() => {
        this.setChannels(response.data.data);
        this.setLoading(false);
      });
      return response.data.data;
    } catch (error) {
      runInAction(() => {
        this.setError(error);
        this.setLoading(false);
      });
      throw new Error(getErrorMessage(error, "Ошибка при добавлении канала"));
    }
  }

  async updateChannel(channelId, channelData) {
    this.setLoading(true);
    this.setError(null);
    try {
      const response = await Api.post(
        `${BASE_API_URL}/api/channel/update/${channelId}`,
        channelData
      );
      runInAction(() => {
        this.setChannels(response.data.data);
        this.setLoading(false);
      });
      return response.data.data;
    } catch (error) {
      runInAction(() => {
        this.setError(error);
        this.setLoading(false);
      });
      const msg =
        error?.response?.data?.error?.message ||
        error?.message ||
        "Ошибка при обновлении канала";
      throw new Error(msg);
    }
  }

  getChannelById(channelId) {
    return this.channels.find((channel) => channel.id === channelId);
  }
}

const channelStore = new ChannelStore();
export default channelStore;
